import {NgModule} from "@angular/core";
import {BillingFiltersFactory} from "./billing-letters/filters.factory";
import {DivisionsFactory} from "./dropdown/divisions.factory";
import {DropdownItemFactory} from "./dropdown/dropdown-item.factory";
import {DropdownSettingsFactory} from "./dropdown/dropdown-settings.factory";

@NgModule({
    providers: [
        BillingFiltersFactory,
        DivisionsFactory,
        DropdownItemFactory,
        DropdownSettingsFactory
    ]
})
export class FactoryModule { }



// WEBPACK FOOTER //
// ./src/app/shared/factories/factory.module.ts